const permitTranslate: Record<string, string> = {
  'STATUS.PERMIT.PENDING': 'Pendiente',
  'STATUS.PERMIT.PAID': 'Pagado',
  'STATUS.PERMIT.DUE': 'Cuotas',
}

export default permitTranslate
